/* eslint-disable no-undef */
import axios from 'axios';
import getReportsBaseUrl from './reportsBaseUrl';
import { configureHttpHeaders, onSuccess, onError } from './apiHelpers';
import { VITE_REPORT_DATA_API } from 'Constants/appEnvConstants'

const REPORT_MANAGER_API = getReportsBaseUrl();

export function getReportData(data, acquirerCode) {
  configureHttpHeaders(axios);
  return get(VITE_REPORT_DATA_API, 'api/v1/reports/settlement', data, acquirerCode);
}

export function documentViewDownloadAction(exportFormat, document) {
  return getBlob(REPORT_MANAGER_API, 'api/v1/reportmanager/report/download', document);
}

export function getInventoryReportData(data, acquirerCode, reportId) {
  configureHttpHeaders(axios);
  const baseUrl = VITE_REPORT_DATA_API;
  const url = 'api/v1/reports/inventory';
  const params = {
    reportGeneratedDate: data,
  };
  return axios
    .get(`${baseUrl}${url}?acquirerCodeList=${acquirerCode}&reportId=${reportId}`, { params })
    .then(onSuccess)
    .catch(onError);
}

export function inventoryViewDownloadAction(exportFormat, document) {
  return getBlob(REPORT_MANAGER_API, 'api/v1/reportmanager/report/download', document);
}

export function exportReportData(data) {
  let url;
  if (data.reportId === '7' || data.reportId === '9') {
    url = `api/v1/reports/product/export`;
  } else {
    url = `api/v1/reports/export`;
  }
  configureHttpHeaders(axios);
  return postBlob(`${VITE_REPORT_DATA_API}${url}`, data);
}

export function getReportNames(acquirerList) {
  configureHttpHeaders(axios);
  return getBase(VITE_REPORT_DATA_API, `api/v1/reports/operations?acquirerCodeList=${acquirerList}`);
}

export function getProductReportNames() {
  configureHttpHeaders(axios);
  return get(VITE_REPORT_DATA_API, 'api/v1/reports/product');
}

export function closeCaseStage(caseStageId) {
  configureHttpHeaders(axios);
  return deletStgae(`api/v1/reports/update/multiplecase/${caseStageId}`);
}

export function reportData(reportId, pageNumber, size, sort, reportSearchView, activeColumns, acquirerAccessList) {
  let sortKeyString = [];
  let sortOrderString = [];
  sort.forEach((element) => {
    sortKeyString.push(element.key);
    sortOrderString.push(element.order ? 'ASC' : 'DESC');
  });
  let data = {
    orderByProperties: sortKeyString,
    pageNumber: pageNumber,
    propertyDirections: sortOrderString,
    size: size,
    reportSearchView: reportSearchView,
    summaryReportColumnKey: activeColumns,
  };
  data['reportId'] = reportId;
  if (!!acquirerAccessList) {
    data['acquirerAccessList'] = acquirerAccessList;
  }
  configureHttpHeaders(axios);
  return postBlob(`${VITE_REPORT_DATA_API}api/v1/reports/operations/data`, data);
}

export function productReportData(
  reportId,
  pageNumber,
  size,
  sort,
  reportSearchView,
  activeColumns,
  acquirerAccessList,
) {
  let sortKeyString = [];
  let sortOrderString = [];
  sort.forEach((element) => {
    sortKeyString.push(element.key);
    sortOrderString.push(element.order ? 'ASC' : 'DESC');
  });
  let data = {
    orderByProperties: sortKeyString,
    pageNumber: pageNumber,
    propertyDirections: sortOrderString,
    size: size,
    reportSearchView: reportSearchView,
    summaryReportColumnKey: activeColumns,
  };
  data['reportId'] = reportId;
  if (!!acquirerAccessList) {
    data['acquirerAccessList'] = acquirerAccessList;
  }
  configureHttpHeaders(axios);
  return postBlob(`${VITE_REPORT_DATA_API}api/v1/reports/product/data`, data);
}

function postBlob(postUrl, body) {
  return axios({
    method: 'post',
    url: postUrl,
    data: body,
  })
    .then(onSuccess)
    .catch(onError);
}

function getBlob(baseUrl, url, document) {
  axios.defaults.headers.common.Accept = 'application/octet-stream';
  configureHttpHeaders(axios);
  let resType = 'text/csv';

  const params = {
    fileName: document.fileName,
    fileDirectoryId: document.fileDirectoryId,
  };

  return axios
    .get(`${baseUrl}${url}`, { params, responseType: 'arraybuffer' })
    .then(onSuccess)
    .then((response) => {
      const blob = new Blob([response], { type: resType });
      return blob;
    })
    .catch(onError);
}

function get(baseUrl, url, data, acquirerCode) {
  const params = {
    reportGeneratedDate: data,
  };
  return axios.get(`${baseUrl}${url}?acquirerCodeList=${acquirerCode}`, { params }).then(onSuccess).catch(onError);
}

function deletStgae(url) {
  return axios.put(`${VITE_REPORT_DATA_API}${url}`).then(onSuccess).catch(onError);
}

function getBase(baseURL, url) {
  return axios.get(`${baseURL}${url}`).then(onSuccess).catch(onError);
}

export default {
  getReportData,
  documentViewDownloadAction,
  getReportNames,
  exportReportData,
  reportData,
  closeCaseStage,
  getInventoryReportData,
  inventoryViewDownloadAction,
  getProductReportNames,
  productReportData,
};
